module.exports = __webpack_public_path__ + "media/images/emblems/WappenSchaenisOriginal-d181f63190d2fe2ce0d4b6ac7eb078f8.png";